// src/pages/Finance.js
import React from 'react';
import './Finance.css';

const Finance = () => {
  return (
    <div className="container">
      <h1 className="title">Financeiro</h1>
      <p className="description">
        Emita a segunda via de boletos e gerencie suas finanças de forma prática e segura.
      </p>
      <a href="https://sistema-de-financeiro.com/emitir-boleto" className="button" target="_blank" rel="noopener noreferrer">
        Acessar Financeiro
      </a>
    </div>
  );
};

export default Finance;